export default {
  BAWithDraw: 33,
  CashPaymentDepositSalary: 163,
};
